import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ui-icon',
  templateUrl: './ui-icon.component.html',
  styleUrls: ['./ui-icon.component.scss']
})
export class UIIconComponent implements OnInit {

  @Input() nameIcon: string = '';

  constructor() { }

  ngOnInit(): void {
  }

}
